/* Manual progressive enhancement only: no timer, autoplay or cart interception. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-pic-worlds]').forEach(worlds => {
      if (worlds.dataset.worldsReady) return;
      worlds.dataset.worldsReady = 'true';
      const panels = [...worlds.querySelectorAll('[data-world-panel]')];
      const buttons = [...worlds.querySelectorAll('[data-world-select]')];
      const controls = worlds.querySelector('[data-world-controls]');
      if (panels.length < 2 || !controls) return;
      const status = worlds.querySelector('[data-world-status]');
      function show(index, announce = true) {
        panels.forEach(panel => { panel.hidden = panel.dataset.worldIndex !== index; });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.worldSelect === index)));
        if (announce && status) status.textContent = `Anwendungsbild ${index} von ${panels.length}: ${buttons.find(button => button.dataset.worldSelect === index)?.textContent || ''}`;
      }
      buttons.forEach(button => button.addEventListener('click', () => show(button.dataset.worldSelect)));
      controls.hidden = false;
      show(panels[0].dataset.worldIndex, false);
      worlds.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-world-panel]');
        if (panel) show(panel.dataset.worldIndex);
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
